import { render, staticRenderFns } from "./XWorkInfo.vue?vue&type=template&id=74b852b9&scoped=true"
import script from "./XWorkInfo.vue?vue&type=script&lang=js"
export * from "./XWorkInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b852b9",
  null
  
)

export default component.exports